import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "app/pages/module/auth/core/Auth";

const onboardingRoutes: Record<string, string> = {
  cleaner: "/cleaner/onboarding",
  company: "/company/onboarding",
  individual: "/individual/onboarding",
};

export const OnboardingGuard = () => {
  const { isAuthenticate, onBoardingStatus, userType } = useAuth();
  const location = useLocation();
  const onboardingRoute = onboardingRoutes[userType];

  if (!isAuthenticate || !onboardingRoute) {
    return <Outlet />;
  }

  if (onBoardingStatus === false && location.pathname !== onboardingRoute) {
    return <Navigate to={onboardingRoute} replace />;
  }

  return <Outlet />;
};
